import React, { useMemo, useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import * as yup from 'yup'

import useTranslation from 'hooks/useTranslations'

import ResendInvitation from 'ui/modules/resendInvitation'

import {
  confirmResendInvitation,
  resendInvitationClear,
} from 'services/invitations/actions'
import * as actionTypesInvitations from 'services/invitations/action-types'
import { showSnackbar } from 'services/snackbar/actions'

import reduceArrayToObject from 'utils/reduceArrayToObject'

const ResendInvitationModal = ({ email, id, isOpen, onClose }) => {
  const t = useTranslation()
  const dispatch = useDispatch()
  const [emailError, setEmailError] = useState('')

  const validationSchema = useMemo(() => {
    return yup.object().shape({
      email: yup.string().email({ emailError: t('error:invalid-email') }),
    })
  }, [t])

  const validateForm = useCallback(
    data =>
      validationSchema.validate(data, { abortEarly: false }).catch(error => {
        const errors = reduceArrayToObject(error.errors)
        throw errors
      }),
    [validationSchema],
  )

  const handleSubmit = async data => {
    const payload = { email: data.email, id: data.invitationId }
    setEmailError('')

    validateForm(payload)
      .then(payload => {
        dispatch(confirmResendInvitation(payload))
        dispatch(
          showSnackbar({
            message: 'invitation:resend',
            actionToDo: {
              type: actionTypesInvitations.RESEND_INVITATION,
              payload,
            },
          }),
        )
      })
      .catch(errors => {
        setEmailError(errors.emailError || '')
      })
  }

  const handleCloseModal = () => {
    onClose()
    dispatch(resendInvitationClear())
  }

  return (
    <ResendInvitation
      invitationEmail={email}
      invitationId={id}
      isOpen={isOpen}
      isDisabled={false}
      emailError={emailError}
      onClose={handleCloseModal}
      onSubmit={handleSubmit}
    />
  )
}

export default ResendInvitationModal
